import React from "react";
import SbToolProjectVersionService from "../../../service/projectVersionService";
import {observer} from "mobx-react";
import FaCaretDown = require("react-icons/lib/fa/caret-down");
import FaCaretUp = require("react-icons/lib/fa/caret-up");
import {MenuHeader, StyledMenu} from "./SidebarCriteriaMenu.styled";
import SidebarMenuItem from "./SidebarMenuItem";

interface Props {
  isValueChanged: boolean
  handleChangeValueState: (bool:boolean)=>void
}
@observer
export default class SidebarCriteriaMenu extends React.Component<Props, any> {

  state = {
    environmental: [],
    social: [],
    economic: [],
    local: [],
    openEnv: true,
    openSoc: false,
    openEco: false,
    openLoc: false,
  }

  componentDidMount() {
    let ENVIRONMENTALcriterias = SbToolProjectVersionService.criteriaList.filter(el=> el.type ==="E")
    let SOCIALcriterias = SbToolProjectVersionService.criteriaList.filter(el=> el.type ==="S")
    let ECONOMICcriterias = SbToolProjectVersionService.criteriaList.filter(el=> el.type ==="C")
    let LOCALcriterias = SbToolProjectVersionService.criteriaList.filter(el=> el.type ==="L")
    this.setState({
      environmental: this.state.environmental.concat(ENVIRONMENTALcriterias),
      social: this.state.environmental.concat(SOCIALcriterias),
      economic: this.state.environmental.concat(ECONOMICcriterias),
      local: this.state.environmental.concat(LOCALcriterias)
    })
  }

  toggleMenuOpen (menuOption:string) {
    switch (menuOption) {
      case "openEnv":
        this.setState( {openEnv: !this.state.openEnv});
        break;
      case "openSoc":
        this.setState( {openSoc: !this.state.openSoc});
        break;
      case "openEco":
        this.setState( {openEco: !this.state.openEco});
        break;
      case "openLoc":
        this.setState( {openLoc: !this.state.openLoc});
        break;
      default:
        break;
    }
  }

  render() {
    const {openEnv,openLoc,openSoc,openEco, environmental,social,local,economic} = this.state

    return (
      <StyledMenu>
        {/*TODO: minimize it to one map func*/}

        {/* tslint:disable-next-line:jsx-no-lambda */}
        <MenuHeader onClick={()=>this.toggleMenuOpen("openEnv")} isActive={openEnv}>
          {openEnv ? <FaCaretUp/> : <FaCaretDown/>}
          <h4>Environmentální kritéria</h4>
        </MenuHeader>
        {openEnv && environmental.map((criterion)=>
        <SidebarMenuItem  key={criterion.criterionId} criterion={criterion}
                          isValueChanged={this.props.isValueChanged}
                          handleChangeValue={this.props.handleChangeValueState}
        />)
        }

        {/* tslint:disable-next-line:jsx-no-lambda */}
        <MenuHeader onClick={()=>this.toggleMenuOpen("openSoc")} isActive={openSoc}>
          {openSoc ? <FaCaretUp/> : <FaCaretDown/> }
          <h4>Sociální kritéria</h4>
        </MenuHeader>
        {openSoc && social.map((criterion)=>
          <SidebarMenuItem key={criterion.criterionId} criterion={criterion}
                           isValueChanged={this.props.isValueChanged}
                           handleChangeValue={this.props.handleChangeValueState}/>)
        }

        {/* tslint:disable-next-line:jsx-no-lambda */}
        <MenuHeader onClick={()=>this.toggleMenuOpen("openEco")} isActive={openEco}>
          {openEco ? <FaCaretUp/> : <FaCaretDown/> }
          <h4>Ekonomika a management</h4>
        </MenuHeader>
        {openEco && economic.map((criterion)=>
          <SidebarMenuItem key={criterion.criterionId} criterion={criterion}
                           isValueChanged={this.props.isValueChanged}
                           handleChangeValue={this.props.handleChangeValueState}/>)
        }

        {/* tslint:disable-next-line:jsx-no-lambda */}
        <MenuHeader onClick={()=>this.toggleMenuOpen("openLoc")} isActive={openLoc}>
          {openLoc ? <FaCaretUp/> : <FaCaretDown/> }
          <h4>Lokalita</h4>
        </MenuHeader>
        {openLoc && local.map((criterion)=>
          <SidebarMenuItem key={criterion.criterionId} criterion={criterion}
                           isValueChanged={this.props.isValueChanged}
                           handleChangeValue={this.props.handleChangeValueState}/>)
        }
      </StyledMenu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/sbtool/component/ProjectVersionParamsForm/SidebarCriteriaMenu/SidebarCriteriaMenu.tsx